import { ComponentProps, forwardRef } from 'react';
import { IonicInput } from 'ionic-ui';

type Props = {
  status?: 'done';
  label?: string;
  fieldType?: string;
  hint?: string;
  className?: string;
};

type IonicInputProps = ComponentProps<typeof IonicInput>;

const SetupItem = forwardRef<HTMLInputElement, Props & IonicInputProps>(
  ({ label, fieldType, hint, className, ...rest }, ref) => {
    return (
      <IonicInput
        ref={ref}
        {...rest}
        size="lg"
        variant="filled"
        type={fieldType}
        label={label}
        aria-label={label}
        hint={hint}
        className={className}
        hintClass="text-red-600 dark:text-red-600"
      />
    );
  }
);

SetupItem.displayName = 'SetupItem';
export default SetupItem;
